import { jsx as _jsx } from "react/jsx-runtime";
import { Ellipsis } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
import { DropdownMenuWithActionSheet } from "~/components/Menus/DropdownMenuWithActionSheet";
export const BoardAncestorsDropdown = /*#__PURE__*/ memo((param)=>{
    let { ancestors, onBoardClick } = param;
    return /*#__PURE__*/ _jsx(DropdownMenuWithActionSheet, {
        isTitleHidden: true,
        options: ancestors.map((param)=>{
            let { id, title } = param;
            return {
                id,
                label: title,
                onSelect: ()=>onBoardClick({
                        id,
                        title
                    }),
                type: "item"
            };
        }),
        title: "Ancestor",
        trigger: /*#__PURE__*/ _jsx(IconButton, {
            appearance: "ghost",
            color: "grey",
            icon: Ellipsis,
            label: "See more boards in pop-up",
            size: "small"
        })
    });
});
BoardAncestorsDropdown.displayName = "BoardAncestorsDropdowns";
